import { useState } from 'react'
import { useTranslation } from 'next-i18next'

import { Link } from '~/components'
import { useAppDispatch } from '~/redux/hooks'

import { CurriculumTopicDataType } from '../types/curriculum.types'
import { clearAndUpdateActiveCompetencyList, setScrollItemIdOnTopicPage } from '../slice/persistCurriculum.slice'

interface Props {
  subject: CurriculumTopicDataType
  subjectUrl: string
  url: string
  onCollapse?: () => void
  onItemClick: (
    subject: CurriculumTopicDataType,
    contentItem: boolean,
    url: string,
    mappingQuizTakenBySubject: boolean,
  ) => void
  mappingQuizTakenBySubject: boolean
}
const CurriculumTopicCollapse = ({
  subject,
  subjectUrl,
  url,
  onCollapse,
  onItemClick,
  mappingQuizTakenBySubject,
}: Props): React.ReactElement => {
  const { t } = useTranslation('curriculum')
  const dispatch = useAppDispatch()

  const [toggleOpen, setToggle] = useState(false)

  const hasMinLength = subject.competencyGoals.length > 3
  const showGradient = hasMinLength && !toggleOpen
  const toggleClass = toggleOpen ? 'max-h-800' : showGradient ? 'max-h-37 md:max-h-32' : 'max-h-800'

  const onCompetencyClick = (index: number): void => {
    const splitUrl = url.split('/')
    const countryCode = splitUrl[2]?.split('-')[1]
    const level = splitUrl[3]
    const id = `${countryCode}_${level}_${index}_competency_subject_${subject.subjectOrder}_quarter`
    dispatch(setScrollItemIdOnTopicPage(''))
    dispatch(clearAndUpdateActiveCompetencyList(id))
    onItemClick(subject, true, subjectUrl, mappingQuizTakenBySubject)
  }

  const getToggleButton = (absolute: boolean): React.ReactElement => {
    return (
      <div
        className={` ${absolute ? `absolute ` : 'mt-4'}  bottom-0 h-11 flex justify-center items-end w-full rounded`}
      >
        <button
          className="h-11 w-38 rounded border mb-2 "
          onClick={() => {
            onCollapse?.()
            setToggle(!toggleOpen)
          }}
        >
          <span className="text-xxs md:text-xs leading-7 sm:leading-8 text-gray-700">
            {t(toggleOpen ? 'showLess' : 'showAll')}
          </span>
        </button>
      </div>
    )
  }

  return (
    <div>
      <div className={`overflow-hidden transition-all duration-500 ${toggleClass} relative`}>
        <ul className="text-white list-disc ml-4 pt-2 px-10 pb-2" data-testid="prerequisites-list">
          {subject.competencyGoals.map((competencyGoal, index) => (
            <Link className="" key={competencyGoal.description} onClick={() => onCompetencyClick(index)} to={url}>
              <li className="text-xs sm:text-base leading-6 text-gray-700">{competencyGoal.description}</li>
            </Link>
          ))}
        </ul>
        <div
          className={`absolute bottom-0 min-h-23 rounded-b w-full bg-gradient-t-to-b-purple ${
            showGradient ? 'opacity-100' : 'opacity-0'
          } transition-all duration-300 pointer-events-none`}
        />
        {hasMinLength && getToggleButton(false)}
        {showGradient && getToggleButton(true)}
      </div>
    </div>
  )
}

export default CurriculumTopicCollapse
